import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { BaseAiChatEventRuntype } from './ai-chat';
import { ClickstreamEventEnum } from 'bc-model';

const AiChatReceivedEventBrowserRuntype = BaseEventRuntype.And(BaseAiChatEventRuntype).And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_ASSIST_RECEIVED),
    version: Literal(1),
  })
);

const AiChatReceivedEventServerRuntype = AiChatReceivedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiChatReceivedBrowserEvent = Static<typeof AiChatReceivedEventBrowserRuntype>;
type AiChatReceivedServerEvent = Static<typeof AiChatReceivedEventServerRuntype>;

const isAiChatReceivedBrowserEvent = (obj: BaseEvent): obj is AiChatReceivedBrowserEvent => {
  return obj.event === 'AI Assist Received';
};

const isAiChatReceivedServerEvent = (obj: BaseEvent): obj is AiChatReceivedServerEvent => {
  return obj.event === 'AI Assist Received';
};

export {
  isAiChatReceivedBrowserEvent,
  isAiChatReceivedServerEvent,
  AiChatReceivedEventBrowserRuntype,
  AiChatReceivedEventServerRuntype,
  type AiChatReceivedBrowserEvent,
  type AiChatReceivedServerEvent,
};
